import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const Login = lazy(() => import('../pages/login/page'));
const Registro = lazy(() => import('../pages/registro/page'));
const Onboarding = lazy(() => import('../pages/onboarding/page'));
const DashboardLayout = lazy(() => import('../pages/dashboard/layout'));
const DashboardInicio = lazy(() => import('../pages/dashboard/inicio/page'));
const MiPlanPage = lazy(() => import('../pages/dashboard/mi-plan/page'));
const EntrenamientosPage = lazy(() => import('../pages/dashboard/entrenamientos/page'));
const WorkoutDetailPage = lazy(() => import('../pages/dashboard/entrenamientos/[id]/page'));
const EjerciciosPage = lazy(() => import('../pages/dashboard/ejercicios/page'));
const NutricionPage = lazy(() => import('../pages/dashboard/nutricion/page'));
const SuplementacionPage = lazy(() => import('../pages/dashboard/suplementacion/page'));
const RehabilitacionPage = lazy(() => import('../pages/dashboard/rehabilitacion/page'));
const SimetriaPage = lazy(() => import('../pages/dashboard/simetria/page'));
const PerfilPage = lazy(() => import('../pages/dashboard/perfil/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const InicioPage = lazy(() => import('../pages/dashboard/inicio/page'));
const LogrosPage = lazy(() => import('../pages/dashboard/logros/page'));
const EntrenadorIAPage = lazy(() => import('../pages/dashboard/entrenador-ia/page'));
const EspecialMedicoPage = lazy(() => import('../pages/dashboard/especial-medico/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/registro',
    element: <Registro />,
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <Onboarding />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <InicioPage />,
      },
      {
        path: 'inicio',
        element: <InicioPage />,
      },
      {
        path: 'mi-plan',
        element: <MiPlanPage />,
      },
      {
        path: 'entrenamientos',
        element: <EntrenamientosPage />,
      },
      {
        path: 'entrenamientos/:id',
        element: <WorkoutDetailPage />,
      },
      {
        path: 'ejercicios',
        element: <EjerciciosPage />,
      },
      {
        path: 'nutricion',
        element: <NutricionPage />,
      },
      {
        path: 'suplementacion',
        element: <SuplementacionPage />,
      },
      {
        path: 'rehabilitacion',
        element: <RehabilitacionPage />,
      },
      {
        path: 'simetria',
        element: <SimetriaPage />,
      },
      {
        path: 'perfil',
        element: <PerfilPage />,
      },
      {
        path: 'logros',
        element: <LogrosPage />,
      },
      {
        path: 'entrenador-ia',
        element: <EntrenadorIAPage />,
      },
      {
        path: 'especial-medico',
        element: <EspecialMedicoPage />,
      },
    ],
  },
  {
    path: '/404',
    element: <NotFound />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;
